import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Language } from './language';
import { OutletLanguagesDTO } from '../outlet/model/outlet';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(private httpClient: HttpClient) {}

  getLanguages(): Observable<Language[]> {
    const url: string = `${environment.prestoUrl}/languages`;
    return this.httpClient.get<Language[]>(url);
  }

  getLanguagesbyCountry(countryCode: string): Observable<string[]> {
    const url: string = `${environment.prestoUrl}/country/${countryCode}/languages`;
    return this.httpClient.get<string[]>(url);
  }

  updateOutletLaguages(
    outletId: number | undefined,
    language: OutletLanguagesDTO
  ): Observable<void> {
    const url = `${environment.prestoUrl}/outlet/${outletId}/languages`;
    return this.httpClient.put<void>(url, language);
  }
}
